import React from "react";
import PopUp, { closePopUp } from "./popUp";
import TextArea from "./textField/textArea";
import Button from "./button";


interface ConfirmPiecePopUpProps {
    onSend: (message: string) => void;
}

export default function ConfirmPiecePopUp(props: ConfirmPiecePopUpProps) {
    const [message, setMessage] = React.useState("");

    return <PopUp className="big" title="Reject Piece">
        <TextArea label="Edits" onChange={setMessage} value={message} placeholder="Reason for rejection" />
        <Button onClick={() => {
            props.onSend(message);
            closePopUp();
        }}>Send</Button>
    </PopUp>
}